import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import type { FunctionalRolesDialogData } from '../role.model';

@Component({
  selector: 'app-functional-roles-dialog',
  templateUrl: './functional-roles-dialog.component.html',
  styleUrl: './functional-roles-dialog.component.scss',
  standalone: false
})
export class FunctionalRolesDialogComponent {
  dialogRef = inject<MatDialogRef<FunctionalRolesDialogComponent>>(MatDialogRef);
  data = inject<FunctionalRolesDialogData>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }
}
